import { type FC } from 'react';

import { Stack } from '@craft/ui/components/structural';

import { POPUP_HEIGHT_IN_PX } from '@/src/components/organisms/SearchBar/helpers';

import { NoResultsFoundDisplay } from './NoResultsFoundDisplay';
import { NoSearchValueDisplay } from './NoSearchValueDisplay';

interface EmptyOptionsDisplayProps {
  readonly isDirty: boolean;
}

export const EmptyOptionsDisplay: FC<EmptyOptionsDisplayProps> = ({ isDirty }) => (
  <Stack alignItems='center' height={POPUP_HEIGHT_IN_PX} justifyContent='center'>
    {isDirty ? <NoResultsFoundDisplay /> : <NoSearchValueDisplay />}
  </Stack>
);
